/*
 * @author: qiuhanwen
 * @description: 首页公告
 */
import { BASEDATASERVICE } from '@/const';
import { OUTBOUND_URL } from '@/const/outbound';
import { tranformRangeTime } from '@/utils';
import { request } from 'ice';

async function getTableList({ current, pageSize }, form) {
  const data = tranformRangeTime('createTime', ['publishStartTime', 'publishEndTime'], form, 'YYYY-MM-DD HH:mm:ss');
  const res = await request.post(`${BASEDATASERVICE}/system/article/page`, {
    data: { ...data },
    pageObj: {
      current,
      pageSize,
    },
  });
  if (res.list && res.list.length) {
    res.list.forEach((i, v) => {
      i.index = v + 1;
    });
  }
  return {
    total: res.totalElements,
    list: res.list,
  };
}

export { getTableList };
